import { useEffect, useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

export const FullscreenButton = ({ target, testid = "fullscreen-btn", className = "" }) => {
  const [fs, setFs] = useState(false);
  useEffect(() => {
    const on = () => setFs(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", on);
    return () => document.removeEventListener("fullscreenchange", on);
  }, []);
  const toggle = () => {
    if (document.fullscreenElement) document.exitFullscreen();
    else (target?.current || document.documentElement).requestFullscreen?.().catch(() => {});
  };
  return (
    <button onClick={toggle} data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full bg-[#0A192F] text-white px-5 py-2.5 text-sm font-bold shadow-lg shadow-[#0A192F]/20 hover:bg-[#FF2E63] transition-[background-color,transform] active:scale-95 ${className}`}>
      {fs ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}{fs ? "Exit Full Screen" : "Full Screen"}
    </button>
  );
};
